import { ActionPayload } from "../types/working-model";

import { Beacon } from "./helpers";

export function SendTrackingEvent(trackingData: ActionPayload): Promise<boolean> {
	return Beacon('/actions', trackingData);
}
